import React from 'react';

export function ToggleUnchecked() {
  return (
    <svg fill='none' height='19' viewBox='0 0 19 19' width='19' xmlns='http://www.w3.org/2000/svg'>
      <rect fill='white' height='19' rx='9.5' width='19' />
    </svg>
  );
}
